<template>
    <div class="dragable-popper" :class="{'auto-bounds':autoBounds}" :style="containerStyle"    >      
        <div class="drag-area" ref="dragArea" @[dragStart]="onDragStart">
            <slot name="title"></slot>
        </div>
        <div class="popper-content">
            <slot name="content"></slot>
        </div>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: "dragable-popper",
    props: {
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 240
        },
        left: {
            type: String,
            default: "auto"
        },
        top: {
            type: String,
            default: "auto"
        },
        right: {
            type: String,
            default: "auto"
        },
        bottom: {
            type: String,
            default: "auto"
        },
        target: Object,
        lock: Boolean
    },
    data(){
        return {
            dragStartX: 0,
            dragStartY: 0,
            translateX: 0,
            translateY: 0,
            cursor: "default",
            autoBounds: false,
            boundsTimer: null
        }
    },
    computed: {
        zIndex(){
            if(this.$ELEMENT){
                return this.$ELEMENT.zIndex - 1;
            } else {
                return 1999;
            }
        }, 
        container(){
            return this.target || document.body;
        },
        containerStyle () {
            return {
                width: this.width + 'px',
                height: this.height + 'px',
                left: this.left,
                top: this.top,
                right: this.right,
                bottom: this.bottom,
                transform: 'translate(' + this.translateX + 'px,' + this.translateY + 'px)',
                cursor: this.cursor,
                zIndex: this.zIndex
            }
        },
        dragEvents(){
            if(this.util$.isMobile$()){
                return {
                    dragStart: 'touchstart',
                    dragMove: 'touchmove',
                    dragEnd: 'touchend'
                }
            } else {
                return {
                    dragStart: 'mousedown',
                    dragMove: 'mousemove',
                    dragEnd: 'mouseup'
                }
            }
        },
        dragStart(){
            return this.dragEvents.dragStart
        }
    },
    watch: {
        height(){
            this.autoCheckBounds();
        },
        width(){
            this.autoCheckBounds();
        },
        left(){
            this.autoCheckBounds();
        },
        top(){
            this.autoCheckBounds();
        },
        right(){
            this.autoCheckBounds();
        },
        bottom(){
            this.autoCheckBounds();
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.checkBounds();
        });
    },
    methods: {
        reset () {
            Object.assign(this, {
                dragStartX: 0,
                dragStartY: 0,
                translateX: 0,
                translateY: 0,
                cursor: "default",
                autoBounds: false,
                boundsTimer: null
            })
            this.autoCheckBounds()
        },
        onDragStart(e){
            if(e.target === this.$refs.dragArea){
                e.preventDefault()
            }
            if (this.lock) return
            console.log("drag start:")
            let x,y;
            if(e.changedTouches){
                x = e.changedTouches[0].clientX;
                y = e.changedTouches[0].clientY;
            } else {
                x = e.clientX;
                y = e.clientY;
            }
            this.dragStartX = x;
            this.dragStartY = y;
            this.cursor = "move";
            this.container.addEventListener(this.dragEvents.dragMove, this.onDragging);
            this.container.addEventListener(this.dragEvents.dragEnd, this.onDragEnd);
            this.container.addEventListener("mouseleave", this.onDragEnd);
        },
        onDragging(e){
            let x,y;
            if(e.changedTouches){
                x = e.changedTouches[0].clientX;
                y = e.changedTouches[0].clientY;
            } else {
                x = e.clientX;
                y = e.clientY;
            }
            this.translateX += (x - this.dragStartX);
            this.translateY += (y - this.dragStartY);
            this.dragStartX = x;
            this.dragStartY = y;
            this.checkBounds();
        },
        onDragEnd(e){
            console.log("drag end:")
            this.onDragging(e);
            this.cursor = "default";
            this.container.removeEventListener(this.dragEvents.dragMove, this.onDragging);
            this.container.removeEventListener(this.dragEvents.dragEnd, this.onDragEnd);
            this.container.removeEventListener("mouseleave", this.onDragEnd);
        },
        checkBounds(){
            let {offsetTop, offsetLeft} = this.$el;
            let {offsetHeight, offsetWidth} = this.container;
            if(offsetTop + this.translateY + this.height > offsetHeight){
                this.translateY = offsetHeight - offsetTop - this.height;
            }
            if(offsetTop + this.translateY < 0){
                this.translateY = -offsetTop;
            }
            if(offsetLeft + this.translateX < 0){
                this.translateX = -offsetLeft;
            }
            if(offsetLeft + this.translateX + this.width > offsetWidth){
                this.translateX = offsetWidth - offsetLeft - this.width;
            }
        },
        autoCheckBounds(){
            if(this.boundsTimer){
                clearTimeout(this.boundsTimer);
                this.boundsTimer = null;
            }
            this.$nextTick(() => {
                this.autoBounds = true;
                this.checkBounds();
                this.boundsTimer = setTimeout(() => {
                    this.autoBounds = false;
                }, 300);
            })
        }
    },
}
</script>
<style lang="scss">
    .dragable-popper{
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: fixed;
        &.auto-bounds{
            transition: transform ease-in 0.3s,height ease-in 0.3s;
        }
        .drag-area{
            width: 100%;
            overflow: hidden;
            border-radius: 10px 10px 0 0;
            &:active{
                cursor: move;
            }
            &>*{
                pointer-events: none;
            }
        }
        .popper-content{
            width: 100%;
            overflow: hidden;
            background: #ffffff;
            border-radius: 0 0 10px 10px;
        }
    }
</style>